export const AdChevron = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='18'
      viewBox='0 0 11 18'
      fill='none'
    >
      <path
        d='M8 15L2 9L8 3'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
